import { BASE_URL, createHeaders, log } from "../utils";

export async function getYoutubeAuthUrl(highlightId: string) {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/youtube_url/${highlightId}`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function uploadVideoToYoutube(highlightId: string) {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/upload_video?highlight_id=${highlightId}`, {
    method: 'POST',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function checkYoutubeAuth() {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/youtube/check-auth`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function generateSignedUrl(userId: string) {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/generate-signed-url?user_id=${userId}`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}